import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import Differentials from "@/components/sections/Differentials";
import Testimonials from "@/components/sections/Testimonials";
import Regions from "@/components/sections/Regions";
import FinalCTA from "@/components/sections/FinalCTA";
import { IMAGES, CONTACT } from "@/data/site";
import { breadcrumbSchema } from "@/lib/schema";

const VALUES = [
  { title: "Agilidade", text: "Resposta imediata em qualquer emergência, 24 horas por dia." },
  { title: "Segurança", text: "Procedimentos corretos que protegem pessoas, veículos e cargas." },
  { title: "Experiência", text: "Mais de 20 anos de estrada em Rondônia e Mato Grosso." },
  { title: "Confiança", text: "Transparência e preço justo em cada atendimento." },
];

export default function QuemSomos() {
  return (
    <>
      <SEO
        title="Quem Somos | Auto Socorro Pimenta | Guincho 24 Horas em RO e MT"
        description="Conheça a Auto Socorro Pimenta: mais de 20 anos de experiência em guincho leve e pesado, transporte de máquinas e auto socorro 24 horas em Rondônia e Mato Grosso."
        path="/quem-somos"
        schemas={[breadcrumbSchema([{ name: "Início", path: "/" }, { name: "Quem Somos", path: "/quem-somos" }])]}
      />

      <PageHeader
        eyebrow="Quem Somos"
        title={<>Mais de {CONTACT.years} anos<br /><span className="text-brand-red">na estrada</span></>}
        subtitle="Uma história construída com trabalho, dedicação e o compromisso de nunca deixar ninguém desamparado na estrada."
        image={IMAGES.fleetDirtLot}
        trail={[{ name: "Início", path: "/" }, { name: "Quem Somos", path: "/quem-somos" }]}
      />

      <section className="bg-brand-obsidian py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
            <Reveal className="relative overflow-hidden">
              <img src={IMAGES.cattleTrailer} alt="Caminhão guincho Auto Socorro Pimenta" loading="lazy" className="w-full rounded-sm object-cover" />
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display text-4xl uppercase leading-[0.95] tracking-tight text-white md:text-5xl">Nossa história</h2>
              <div className="mt-6 space-y-4 text-sm leading-relaxed text-white/65 md:text-base">
                <p>A Auto Socorro Pimenta nasceu da vontade de oferecer um atendimento de qualidade a quem mais precisa: o motorista parado na estrada, a empresa com uma carga a movimentar e a seguradora que exige agilidade. Há mais de {CONTACT.years} anos, percorremos as rodovias de Rondônia e Mato Grosso resolvendo emergências de todos os tipos.</p>
                <p>Ao longo dessa trajetória, investimos continuamente em equipamentos modernos e no treinamento da nossa equipe. Hoje contamos com uma frota completa de guinchos leves, pesados e caminhões munck, preparada para atender desde um carro de passeio até uma carreta de grande porte.</p>
                <p>Nosso maior patrimônio, porém, é a confiança conquistada junto aos nossos clientes. Atuamos com transparência, respeito e preço justo, e é por isso que tantas pessoas e empresas da região voltam a nos procurar sempre que precisam. Atendemos em rodovias e áreas urbanas, 24 horas por dia, todos os dias do ano.</p>
                <p>Com filiais em Pimenta Bueno, Vilhena e Sapezal, ampliamos nossa presença para oferecer o atendimento mais rápido possível em toda a região. Seja qual for a sua emergência, a Auto Socorro Pimenta está pronta para ajudar.</p>
              </div>
            </Reveal>
          </div>

          <div className="mt-16 grid grid-cols-2 gap-4 lg:grid-cols-4">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.05}>
                <div className="h-full rounded-sm border border-white/10 bg-brand-coal p-6 transition-colors duration-300 hover:border-brand-red">
                  <h3 className="font-heading text-lg font-semibold uppercase tracking-wide text-brand-red">{v.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/55">{v.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Differentials />
      <Testimonials />
      <Regions />
      <FinalCTA />
    </>
  );
}
